/**
 * Created by stonewang on 2017/8/24.
 */
import Reflux from 'reflux';
/**
 * 1、Store 和 Actions 的名称需要保持一致。要求这两个词的前缀或后缀相同。
 * 2、createActions接收的参数要和Store中的方法保持一致
 */
export const LinkmanActions = Reflux.createActions([
  'paramChange',
  'useStoreChange',
]);

export class LinkmanStore extends Reflux.Store {
  constructor()
  {
    super();
    this.state = {
      useStore: false,
      params: {
        //id: '',
        s: 10,
        p: 1,
      }
    };
    this.listenables = LinkmanActions;
  }
  useStoreChange(flag){
    this.setState({
      ...this.state,
      useStore: flag
    });
  }
  paramChange(data){
    this.setState({
      ...this.state,
      params:{
        ...this.state.params,
        ...data
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/routes/linkman/store.js